/**
 * @module store/modules/supervisor
 * @description Supervisor Vuex module for monitoring agents and livechat sessions.
 *
 * This module provides functionality for:
 * - Monitoring online and offline agents
 * - Viewing agent chat workload and status
 * - Managing different chat categories (in-queue, on-going, abandoned, resolved)
 * - Filtering chats by department and agent
 */

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { SupervisorState } from "./types";
import { RootState } from "@/store/types";

const supervisor: Module<SupervisorState, RootState> = {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default supervisor;
